import { createContext } from "react";

export type AudioPlayerContext = {
    audioUrl?: string;
    open: boolean;
    minimized: boolean;
    title: string;
    isPlaying: boolean;
    playbackRate: number;
    setOpen: (open: boolean) => void;
    setMinimized: (minimized: boolean) => void;
    setAudioUrl: (url: string) => void;
    setTitle: (title: string) => void;
    setIsPlaying: (isPlaying: boolean) => void;
    setPlaybackRate: (playbackRate: number) => void;
};
const audioPlayerContext = createContext<AudioPlayerContext>(null);

export { audioPlayerContext };